import React from "react";

class HomeDeliveryIcon extends React.PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <defs>
          <style>
            .a{"{fill:none;}"}.b{"{fill:#333;}"}
          </style>
        </defs>
        <path class="a" d="M0,0H24V24H0Z" />
        <path
          class="b"
          d="M12,5.69l5,4.5V18H15V12H9v6H7V10.19l5-4.5M12,3,2,12H5v8h6V14h2v6h6V12h3Z"
          transform="translate(0 0)"
        />
      </svg>
    );
  }
}

export default HomeDeliveryIcon;
